import React from 'react';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { Row, Col } from '@saucelabs/sl-component-grid';
import {
  ControlLabel, FinalInputNumber,
  NewInputText,
  parseFinalFormErrors,
} from '@saucelabs/sl-component-form';
import validate from '@saucelabs/sl-util-validate';

const constraints = {
  name: { presence: { allowEmpty: false } },
  virtual_machines: { presence: { allowEmpty: false } },
};

const AddGroupForm = ({ createGroup, formHandler, limits, onCreateGroupSuccess }) => (
  <Form
    onSubmit={(values) => (
      createGroup(values)
        // react-final-form requires forms to resolve with no value on success
        .then(() => { onCreateGroupSuccess(); return null; })
        .catch(({ response }) => parseFinalFormErrors(response.data, 'Line of Business creation failed!'))
    )}
    render={({ handleSubmit }) => {
      formHandler.submit = handleSubmit; // eslint-disable-line no-param-reassign

      return (
        <form onSubmit={handleSubmit}>
          <Row>
            <Col xs={6}>
              <Field
                className="form-control"
                component={NewInputText}
                id="name"
                label="Line of Business Name"
                name="name"
                type="name"
              />
            </Col>
          </Row>
          <Row>
            <Col xs>
              <Field
                className="form-control"
                component={NewInputText}
                id="description"
                label="Line of Business Description"
                name="description"
                type="text"
              />
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <Row>
                <Col xs={12}>
                  <ControlLabel>Line of Business VM concurrency limits</ControlLabel>
                </Col>
              </Row>
              <Row>
                <Col xs={6}>
                  <FinalInputNumber
                    id="virtual_machines"
                    initialValue={0}
                    label="Virtual Machines"
                    maxValue={limits.virtual_machines}
                    minValue={0}
                    name="virtual_machines"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </form>
      );
    }}
    validate={(values) => validate(values, constraints, { format: 'grouped' })}
  />
);

AddGroupForm.propTypes = {
  createGroup: PropTypes.func.isRequired,
  formHandler: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  limits: PropTypes.object.isRequired,
  onCreateGroupSuccess: PropTypes.func.isRequired,
};

export default AddGroupForm;
export { AddGroupForm };
